<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title class="primary">
                        <v-toolbar-title style="color: white;">
                            Tramitar Pago
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="white">mdi-file-document-multiple-outline</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-data-table :headers="headers"
                                              :loading="show"
                                              loading-text="Cargando... espere un momento"
                                              no-data-text="No hay datos disponibles"
                                              :items="datos"
                                              :footer-props="{
                                                  'items-per-page-options': [20, 50, 100],
                                                  'items-per-page-text':'Registros por página'
                                                }">
                                    <template v-slot:item.actions="{ item }">
                                        <v-btn color="success" 
                                               v-on:click="ValidarPago(item);"
                                               small
                                               fab
                                               dark>
                                            <v-icon>
                                                mdi-file-move-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>

                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import servicio from '@/services/TramitePago/TramitePago.Service.js';

    export default {
        title() {
            return this.$route.meta.title
        },
        data: () => ({
            datos: [],
            show: true,
            headers: [
                { text: 'Contrarecibo', value: 'tpcontrarecibo', class: "text title" },
                { text: 'Abogado', value: 'prnombre', class: "text title" },
                { text: 'Total', value: 'MontoTotal', class: 'text title' },
                { text: 'Acción', value: 'actions', sortable: false },
            ],

        }),
        computed: {
            ...mapState([
                "domain",
                "informationPage",
                "paginacion",
                "permission",
                "user"
            ]),
        },
        methods: {
            ObtenerRegistros() {
                servicio.ObtenerRegistroContrarecibo(this).then(data => {
                    this.datos = data;
                    this.show = false;
                });
            },
            ValidarPago(item) {
                this.$router.push({ name: `RealizarPago`, params: { contrarecibo: item.tpcontrarecibo, prclave: item.prclave } });
            }
        },
        mounted() {
            this.ObtenerRegistros();
        }
    }
</script>